module.exports = "https://www.gc-qa.gnp.com.mx/162df52d1bc5a2330324b0801e5cab6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-up.svg
// module id = 130
// module chunks = 0 1